/* eslint-disable no-return-assign */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Rating from '@material-ui/lab/Rating';
import { Box, Typography, Icon, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const FeedbackForm = ({ onSubmit, onCancel, rating, trainingSessionId }) => {
  const { t } = useTranslation('common');

  const ratingNameById = {};
  const ratingData = {
    sessionQuality: rating.sessionQuality ?? rating.courseQuality ?? null,
    trainersQualityArray: (rating.trainersQualityArray || []).map(item => ({
      trainerId: item.trainerId,
      trainerQuality: item.trainerQuality ?? item.complaintValue ?? null,
    })),
  };
  (rating.trainersQualityArray || []).forEach(item => {
    ratingNameById[item.trainerId] = item.fullName;
  });

  const [value, setValue] = useState(ratingData);

  return (
    <>
      <Box mb={3}>
        <Typography component="legend">{t('formLabels.training')}</Typography>
        <Rating
          name="sessionQuality"
          value={value.sessionQuality}
          onChange={(event, newValue) => {
            setValue({ ...value, sessionQuality: newValue });
          }}
          emptyIcon={<Icon>star_border</Icon>}
        />
      </Box>
      {value.trainersQualityArray.map(trainer => (
        <Box mb={3} key={trainer.trainerId}>
          <Typography component="legend">
            {t('formLabels.trainer')} <small>({ratingNameById[trainer.trainerId]})</small>
          </Typography>
          <Rating
            name={trainer.trainerId}
            value={trainer.trainerQuality}
            onChange={(event, newValue) => {
              const trainerRatingId = event.currentTarget.name;
              const trainersData = [...value.trainersQualityArray].map(item => {
                if (trainerRatingId === item.trainerId.toString()) {
                  // eslint-disable-next-line no-param-reassign
                  item.trainerQuality = newValue;
                }
                return item;
              });
              setValue({ ...value, trainersQualityArray: trainersData });
            }}
            emptyIcon={<Icon>star_border</Icon>}
          />
        </Box>
      ))}
      <Box display="flex" justifyContent="space-between">
        <Button mr={1} onClick={() => onSubmit(trainingSessionId, value)} type="submit" variant="outlined" size="large">
          {t('buttons.save')}
        </Button>
        <Button ml={1} onClick={onCancel} type="reset" variant="outlined" size="large">
          {t('buttons.cancel')}
        </Button>
      </Box>
    </>
  );
};

FeedbackForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  rating: PropTypes.shape({
    sessionQuality: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
    courseQuality: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
    trainersQualityArray: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  trainingSessionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default FeedbackForm;
